export function getRealClassNames(className: string) {
  const valClasses = className.split(/\s+/);
  return valClasses;
}
